import { createFileRoute } from '@tanstack/react-router';
import TimesheetEmployeeDetail from 'containers/Timesheets/TimesheetEmployeeDetail';
import {
  resolveTimesheetRange,
  validateTimesheetSearch,
  type TimesheetRange,
} from 'containers/Timesheets/timesheetRange';

export const Route = createFileRoute('/_authenticated/timesheets/employees/$empId')({
  validateSearch: validateTimesheetSearch,
  component: TimesheetEmployeePage,
});

function TimesheetEmployeePage() {
  const { empId } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const range = resolveTimesheetRange(search);

  const handleRangeChange = (next: TimesheetRange) => {
    navigate({ search: next });
  };

  return (
    <TimesheetEmployeeDetail
      key={empId}
      empId={empId}
      range={range}
      onRangeChange={handleRangeChange}
      onBack={() => navigate({ to: '/timesheets', search: range })}
      onOpenEmployee={(nextEmpId) =>
        navigate({ to: '/timesheets/employees/$empId', params: { empId: nextEmpId }, search: range })
      }
    />
  );
}
